
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'VulnerabilityFilterSwitch',
  model: {
    prop: 'selectedFilter',
    event: 'change'
  },
  props: {
    selectedFilter: {
      type: String,
      default: 'severity'
    }
  },
  computed: {
    activeFilter: {
      get() {
        return this.selectedFilter
      },
      set(value: string) {
        this.$emit('change', value)
      }
    }
  }
})
